import React, { useState } from 'react';
import { useKeyboardShortcuts } from '../hooks/useKeyboardShortcuts';

const KeyboardShortcuts = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { shortcuts, canUndo, canRedo } = useKeyboardShortcuts();

  return (
    <>
      {/* Botão para abrir/fechar - Oculto no Mobile */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="hidden md:block fixed bottom-3 left-3 bg-gray-800 text-white p-2.5 rounded-full shadow-lg hover:bg-gray-700 transition-colors z-50 focus-visible:ring-2 focus-visible:ring-white/70"
        title="Atalhos de Teclado"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </button>

      {/* Modal com atalhos */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" role="dialog" aria-modal="true" aria-labelledby="shortcuts-title">
          <div className="bg-white rounded-md p-5 max-w-sm w-full mx-4 shadow-xl">
            <div className="flex items-center justify-between mb-3.5">
              <h3 id="shortcuts-title" className="text-base font-semibold text-gray-800">
                Atalhos de Teclado
              </h3>
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="space-y-2.5">
              {Object.entries(shortcuts).map(([key, description]) => (
                <div key={key} className="flex items-center justify-between py-1.5 border-b border-gray-100 last:border-b-0">
                  <span className="text-xs text-gray-600">{description}</span>
                  <kbd className="px-1.5 py-0.5 bg-gray-100 text-gray-700 text-[10px] rounded border">
                    {key}
                  </kbd>
                </div>
              ))}
            </div>

            {/* Status do histórico */}
            <div className="mt-3.5 p-2.5 bg-gray-50 rounded-md">
              <h4 className="text-xs font-medium text-gray-700 mb-1.5">Status do Histórico</h4>
              <div className="flex items-center space-x-3 text-xs">
                <div className="flex items-center space-x-2">
                  <div className={`w-2.5 h-2.5 rounded-full ${canUndo ? 'bg-green-500' : 'bg-gray-300'}`}></div>
                  <span className="text-gray-600">Desfazer disponível</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className={`w-2.5 h-2.5 rounded-full ${canRedo ? 'bg-green-500' : 'bg-gray-300'}`}></div>
                  <span className="text-gray-600">Refazer disponível</span>
                </div>
              </div>
            </div>

            <div className="mt-3 text-[11px] text-gray-500 text-center">
              Dica: Use os atalhos para trabalhar mais rapidamente!
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default KeyboardShortcuts;
